import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from './BetaBadge.module.css';

const cx = classnames.bind(styles);

/**
 * BETA badge component for indicating features in beta testing.
 * Used on the EV Charging page and navigation entry.
 */
export default function BetaBadge({ className }) {
  return (
    <span className={cx('badge', className)}>
      BETA
    </span>
  );
}

BetaBadge.propTypes = {
  className: PropTypes.string,
};

BetaBadge.defaultProps = {
  className: undefined,
};
